module.exports = __webpack_public_path__ + "templates/register-activate.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/register-activate.html
// module id = /ORG
// module chunks = 1